<template>
  <div class="fct-phone-input">
    <fct-input :disabled="!value.country_code" :prefix="countryCode" v-model.trim="value.number"></fct-input>
    <country-code-select :disabled="true" :country-code="value.country_code" @input="onCountryCodeChange" :options="countryCodeDetails"
                      class="area-code-select" ></country-code-select>
  </div>
</template>

<script>
  import CountryCodeSelect from './CountryCodeSelect'
  import countryCodeDetails from './countryCodeDetails'

  export default {
    components: {CountryCodeSelect},
    props: ['value'],
    data() {
      return {
        countryCodeDetails
      }
    },
    methods: {
      onCountryCodeChange(country) {
        if (!country || this.value.country_code === country.countryCode) return

        this.value.country_code = country.countryCode;
        this.value.country_iso = country.isoCode;

        this.$emit('input', this.value);
      }
    },
    computed: {
      countryCode () {
        return '+' + this.value.country_code
      }
    }
  }
</script>

<style scoped lang="scss">
  .fct-phone-input {
    position: relative;
    z-index: 1000;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);

    .fct-input {
      padding-left: 100px;
    }

    .area-code-select {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 90px;
    }
  }
</style>
